module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<button id=\"request-report\" class=\"btn btn-secondary filter-card-btn request-report-btn\"> <div>Request CSV</div> ")
    ;  if(locals.maxDays) { 
    ; __append(" <small class=\"text-gray300\">(max: ")
    ; __append(escapeFn( locals.maxDays ))
    ; __append(" days)</small> ")
    ;  } 
    ; __append(" </button> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/request_report/template.ejs
// module id = 1271
// module chunks = 1